var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMilestoneCompleted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54 9.874 9.874 1.54c.07-.07.182-.07.252 0l8.334 8.334c.07.07.07.182 0 .252l-8.334 8.334a.179.179 0 0 1-.252 0L1.54 10.126a.178.178 0 0 1 0-.252Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.929 14 6 9.749l1.25-1.346L9.928 11.3 15.75 5 17 6.354 9.929 14Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 10 10 0l10 10-10 10z"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgMilestoneCompleted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/milestone-completed.036984ba629dfb7d9fc061bd5f7d815b.svg";